import { render, staticRenderFns } from "./TermsofService.vue?vue&type=template&id=79aaefe0&scoped=true&"
import script from "./TermsofService.vue?vue&type=script&lang=ts&"
export * from "./TermsofService.vue?vue&type=script&lang=ts&"
import style0 from "./TermsofService.vue?vue&type=style&index=0&id=79aaefe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79aaefe0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VMain})
